import React from 'react';
import cn from 'classnames';

import { isProductHearted } from 'helpers/HeartUtils';

interface Style {
  styleId: string;
}

interface Props {
  cssHeartActive: string;
  style: Style;
  cssHeartContainer?: string;
  extraRecoStyle?: string | null;
  forceShowHearted?: boolean;
  handleHeartClick?: (...args: any[]) => any;
  isUninteractive?: boolean;
  hearts?: any; // TODO ts type this when `hearts` are typed
  heartsList?: any; // TODO ts type this when `hearts` are typed
  showFavoriteHeart?: boolean;
  productId?: string;
  merchantId?: string;
  compactCount?: boolean;
  isDisplayCount?: boolean;
  testId?: string | null;
}
const Heart = ({
  cssHeartActive,
  cssHeartContainer,
  extraRecoStyle = null,
  forceShowHearted,
  handleHeartClick = f => f,
  isUninteractive = false,
  hearts,
  heartsList,
  showFavoriteHeart,
  style,
  productId,
  compactCount = false,
  isDisplayCount = true,
  testId = null
}: Props) => {
  const { styleId } = style;

  if (!(heartsList && showFavoriteHeart)) {
    return null;
  }

  const isHearted = typeof forceShowHearted === 'boolean' ? forceShowHearted : isProductHearted(showFavoriteHeart, hearts, styleId);
  let count = heartsList[styleId] > 0 || !isHearted ? heartsList[styleId] : 1;

  if (compactCount) {
    count = count > 1000 ? `${Math.floor(count / 1000)}k` : count;
  }

  count = count || 0;
  const ariaLabel = count === 1 ? `${count} person has favorited this.` : `${count} people have favorited this.`;

  if (isUninteractive) {
    return (
      <span data-test-id={testId} className={cn(cssHeartContainer, { [cssHeartActive]: isHearted }, extraRecoStyle)} aria-label={ariaLabel}>
        {count}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={cn(cssHeartContainer, { [cssHeartActive]: isHearted }, extraRecoStyle)}
      aria-pressed={isHearted}
      aria-label="Favorite this item."
      onClick={handleHeartClick(style, productId)}
      data-test-id={testId}
    >
      {isDisplayCount && <span aria-label={ariaLabel}>{count}</span>}
    </button>
  );
};

export default Heart;
